import { render, staticRenderFns } from "./FormStoryFacebook.vue?vue&type=template&id=59bcfbf7&"
import script from "./FormStoryFacebook.vue?vue&type=script&lang=js&"
export * from "./FormStoryFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports